import { AffirmLogo } from '@shared/react-ui-core';
import Imgix from 'react-imgix';
import { Modal, VisuallyHidden } from '@shared/cove-ui';

export const AffirmModalContent: React.FC<{}> = () => {
  return (
    <Modal.Content
      className="w-full max-w-[90%] bg-transparent p-0 shadow-none lg:max-w-[850px]"
      overlayClasses="fixed inset-0 flex items-center justify-center overflow-auto bg-cove-dove/80 py-8 backdrop-blur-sm transition-opacity"
    >
      <div className="relative my-auto flex w-full flex-col items-center rounded bg-white p-cove-15 text-center sm:p-cove-25 md:px-cove-75 md:py-cove-35">
        <VisuallyHidden>
          <h3>Affirm, buy now, pay later</h3>
        </VisuallyHidden>
        <AffirmLogo className="mt-cove-15 h-cove-50" />
        <p className="mt-cove-35 text-3xl font-semibold sm:text-4xl">
          Buy now, Pay Later
        </p>
        <p className="mt-cove-25 text-base font-semibold sm:text-xl">
          Rate from 0 - 30% APR.
        </p>
        <div className="mt-cove-25 flex w-full justify-evenly gap-cove-25 md:mt-cove-50">
          <div className="flex w-full max-w-[275px] flex-col items-center">
            <Imgix
              width={50}
              height={50}
              src="https://www.datocms-assets.com/10154/1744919054-affirm-clock.png"
            />
            <p className="mt-cove-15 text-xl font-semibold sm:text-2xl md:mt-cove-25">
              Quick and Easy
            </p>
            <p className="mt-cove-5 text-sm font-medium sm:text-base md:mt-cove-15">
              Enter a few pieces of information for a real-time decision
            </p>
          </div>

          <div className="flex w-full max-w-[275px] flex-col items-center">
            <Imgix
              width={50}
              height={50}
              src="https://www.datocms-assets.com/10154/1744919092-affirm-fees.png"
            />
            <p className="mt-cove-15 text-xl font-semibold sm:text-2xl md:mt-cove-25">
              No hidden fees
            </p>
            <p className="mt-cove-5 text-sm font-medium sm:text-base md:mt-cove-15">
              Know up front what you'll owe, with no hidden costs and no
              suprises
            </p>
          </div>
        </div>
        <p className="mt-cove-25 text-sm font-light sm:text-base md:mt-cove-50 md:leading-7">
          A down payment may be required. Subject to eligibility check and
          approval. Payment options depend on your purchase amount. Estimated
          payment amount excludes taxes and shipping fees. Actual terms may
          vary. Affirm loans are made by Cross River Bank, Member FDIC.
        </p>
        <p className="mt-cove-15 w-full text-center text-sm font-light sm:text-base">
          Visit{' '}
          <a
            className="cursor-pointer hover:underline"
            href="https://www.affirm.com/help"
          >
            affirm.com/help
          </a>{' '}
          for more info.
        </p>
      </div>
    </Modal.Content>
  );
};
